module.exports = __webpack_public_path__ + "img/why-buy.d35dedcb.png";